import {
  Colors,
  Flex,
  HorizontalSpacing,
  IconCoupon,
  IconInfo,
  IconShare,
  PrimaryButton,
  RemoteImage,
  Tag,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import React, { useCallback } from 'react';
import { useMarketDetail } from '../../queries/useMarketDetail';
import { useMarketSno } from '../../hooks/useMarketSno';
import { IconButton } from './components/IconButton';
import { LabelCount } from './components/LabelCount';
import { IconOnlyButton } from './components/IconOnlyButton';
import { useOnPressFavoriteMarket } from '../../hooks/useOnPressFavoriteMarket';
import { useShowMarketCouponListBottomSheet } from '../../hooks/useShowMarketCouponListBottomSheet';
import { DeviceInfo, isAndroid, isIOS } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { Share } from 'react-native';
import { useLogClickCouponList } from './hooks/useLogClickCouponList';
import { useLogClickShare } from './hooks/useLogClickShare';
import { useIsFavoriteMarket } from '../../hooks/useIsFavoriteMarket';

const MarketInfoWrapper = () => {
  return <MarketInfo />;
};

const MarketInfo = () => {
  const marketId = useMarketSno();
  const { data: marketDetail } = useMarketDetail(marketId);

  // const calcCount = useCallback((count: number) => {
  //   if (count >= 100000000) {
  //     return `${(count / 100000000).toFixed(1)}억`;
  //   }
  //   if (count >= 10000) {
  //     return `${(count / 10000).toFixed(1)}만`;
  //   }
  //   if (count >= 1000) {
  //     return `${(count / 1000).toFixed(1)}천`;
  //   }
  //   return `${count}`;
  // }, []);

  const { show: showMarketCouponList } = useShowMarketCouponListBottomSheet();
  const logClickCouponList = useLogClickCouponList();
  const logClickShare = useLogClickShare();

  const { openDeeplink } = useOpenDeeplink();

  const onPressMarketInfo = useCallback(async () => {
    if (!marketDetail) return;
    const { information_deeplink } = marketDetail.market;

    if (isIOS && (await DeviceInfo.getVersion()) === '2.334.0') {
      const changedDeeplink = information_deeplink.replace(
        `url=market/`,
        'url=https://m.a-bly.com/market/',
      );
      openDeeplink(changedDeeplink);
      return;
    }
    openDeeplink(information_deeplink);
  }, [marketDetail, openDeeplink]);
  // const onPressStyleReview = useCallback(() => {}, []);
  // const onPressAiFitting = useCallback(() => {}, []);

  const onPressCoupon = useCallback(() => {
    logClickCouponList();
    showMarketCouponList({ marketId });
  }, [marketId, showMarketCouponList, logClickCouponList]);

  const onPressShare = useCallback(() => {
    if (!marketDetail) return;

    logClickShare();

    Share.share({
      message: isAndroid ? marketDetail.market.share_link : undefined,
      url: marketDetail.market.share_link,
    });
  }, [logClickShare, marketDetail]);

  const onPressLikeMarket = useOnPressFavoriteMarket({
    sno: marketId,
    listId: marketDetail?.market.recommended_market_list_id ?? '',
    marketName: marketDetail?.market.name ?? '',
    recommendedMarketList: marketDetail?.market.recommended_markets ?? [],
    favorite: marketDetail?.market.favorite ?? null,
  });

  const { isFavoriteMarket: alreadyFavoriteMarket } = useIsFavoriteMarket(
    marketId,
  );

  // const testGroupB = useExperimentGroup({
  //   sno: 'EXP1509',
  //   targetGroups: ['B'],
  // });
  // const testGroupC = useExperimentGroup({
  //   sno: 'EXP1509',
  //   targetGroups: ['C'],
  // });

  if (!marketDetail) return null;

  // if (testGroupB || testGroupC) {
  //   return (
  //     <Flex
  //       padding={{ vertical: 16, horizontal: 16 }}
  //       backgroundColor={'white'}
  //     >
  //       <Flex.Row>
  //         <Flex
  //           width={56}
  //           height={56}
  //           borderRadius={28}
  //           overflow={'hidden'}
  //           borderWidth={1}
  //           borderColor={'border_transparent'}
  //         >
  //           <RemoteImage
  //             width={56}
  //             height={56}
  //             uri={marketDetail.market.image}
  //           />
  //         </Flex>
  //
  //         <HorizontalSpacing size={16} />
  //         <Flex flex={1} gap={4}>
  //           <Typography type={'h5'}>{marketDetail.market.name}</Typography>
  //           <Flex.Row alignItems={'center'} justifyContent={'space-between'}>
  //             <Flex.Row gap={8} alignItems={'center'}>
  //               {marketDetail.market.is_official && (
  //                 <Tag color="blue" size="xsmall" type="secondary">
  //                   공식
  //                 </Tag>
  //               )}
  //               <Tag color="gray" size="xsmall" type="secondary">
  //                 {marketDetail.market.market_type.name}
  //               </Tag>
  //               {aiStudioProductInfo &&
  //                 aiStudioProductInfo.deeplink !== null && (
  //                   <IconButton
  //                     icon={<IconChevronRight />}
  //                     onPress={() => {
  //                       if (!aiStudioProductInfo.deeplink) return;
  //                       logClickAiStudioConcept(aiStudioProductInfo.title);
  //                       bridge.openDeeplink(
  //                         aiStudioProductInfo.deeplink.replace('ably://', '/'),
  //                       );
  //                     }}
  //                     label={'마켓 모델 체험하기'}
  //                     typographyType={'subtitle4'}
  //                   />
  //                 )}
  //             </Flex.Row>
  //           </Flex.Row>
  //           <Flex.Row gap={20}></Flex.Row>
  //         </Flex>
  //         <Flex
  //           alignItems={'center'}
  //           justifyContent={'center'}
  //           onPress={onPressLikeMarket.action}
  //         >
  //           {onPressLikeMarket.loading ? (
  //             <Flex
  //               width={28}
  //               height={28}
  //               alignItems={'center'}
  //               justifyContent={'center'}
  //             >
  //               <Spinner size={20} color={'content_pink_primary'} />
  //             </Flex>
  //           ) : alreadyFavoriteMarket ? (
  //             <IconHeartFill
  //               width={28}
  //               height={28}
  //               fill={ContentColors['content_pink_primary']}
  //             />
  //           ) : (
  //             <IconHeart
  //               width={28}
  //               height={28}
  //               fill={ContentColors['content_pink_primary']}
  //             />
  //           )}
  //           <Typography type={'body5'} color={'content_tertiary'}>
  //             {calcCount(marketDetail.market.favorites_count)}
  //           </Typography>
  //         </Flex>
  //       </Flex.Row>
  //       <VerticalSpacing size={16} />
  //
  //       <Flex.Row alignItems={'center'} justifyContent={'center'}>
  //         <Flex flex={1} alignItems={'center'}>
  //           <LabelCount
  //             label={'상품찜'}
  //             count={marketDetail.market.goods_likes_count}
  //           />
  //         </Flex>
  //         <Flex
  //           width={1}
  //           height={12}
  //           backgroundColorValue={Colors.border_tertiary}
  //           margin={{ horizontal: 12 }}
  //         />
  //         <Flex flex={1} alignItems={'center'}>
  //           <LabelCount
  //             label={'만족도'}
  //             count={marketDetail.market.purchasing_satisfaction_ratio}
  //             isPercent={true}
  //           />
  //         </Flex>
  //
  //         <Flex
  //           width={1}
  //           height={12}
  //           backgroundColorValue={Colors.border_tertiary}
  //           margin={{ horizontal: 12 }}
  //         />
  //         <Flex flex={1} alignItems={'center'}>
  //           {!marketDetail.market.is_exited && (
  //             <IconButton
  //               icon={<IconInfo />}
  //               onPress={onPressMarketInfo}
  //               typographyType={'body3'}
  //               label={'마켓정보'}
  //             />
  //           )}
  //         </Flex>
  //       </Flex.Row>
  //     </Flex>
  //   );
  // }

  return (
    <Flex padding={{ vertical: 24, horizontal: 16 }} backgroundColor={'white'}>
      <Flex.Row>
        <Flex
          width={56}
          height={56}
          borderRadius={28}
          overflow={'hidden'}
          borderWidth={1}
          alignItems={'center'}
          justifyContent={'center'}
          borderColor={'border_transparent'}
        >
          <RemoteImage width={56} height={56} uri={marketDetail.market.image} />
        </Flex>
        <HorizontalSpacing size={16} />
        <Flex flex={1} gap={2}>
          <Flex.Row alignItems={'center'} justifyContent={'space-between'}>
            <Flex.Row gap={8} alignItems={'center'}>
              {marketDetail.market.is_official && (
                <Tag color="blue" size="xsmall" type="secondary">
                  공식
                </Tag>
              )}
              <Tag color="gray" size="xsmall" type="secondary">
                {marketDetail.market.market_type.name}
              </Tag>
            </Flex.Row>
            {!marketDetail.market.is_exited && (
              <IconButton
                icon={<IconInfo />}
                onPress={onPressMarketInfo}
                typographyType={'body5'}
                label={'마켓정보'}
              />
            )}
          </Flex.Row>
          <Typography type={'h5'}>{marketDetail.market.name}</Typography>
        </Flex>
      </Flex.Row>
      <VerticalSpacing size={12} />
      <Flex.Row alignItems={'center'} justifyContent={'center'}>
        <LabelCount
          label={'마켓 찜'}
          count={marketDetail.market.favorites_count}
        />
        <Flex
          width={1}
          height={12}
          backgroundColorValue={Colors.border_tertiary}
          margin={{ horizontal: 20 }}
        />
        <LabelCount
          label={'상품 찜'}
          count={marketDetail.market.goods_likes_count}
        />
        <Flex
          width={1}
          height={12}
          backgroundColorValue={Colors.border_tertiary}
          margin={{ horizontal: 20 }}
        />
        <LabelCount
          label={'마켓 만족도'}
          count={marketDetail.market.purchasing_satisfaction_ratio}
          isPercent={true}
        />
      </Flex.Row>
      <VerticalSpacing size={16} />

      <Flex.Row gap={8}>
        <Flex flex={1}>
          <PrimaryButton
            color={alreadyFavoriteMarket ? 'gray' : 'pink'}
            outline={alreadyFavoriteMarket}
            size="medium"
            variant="fill"
            state={onPressLikeMarket.loading ? 'loading' : undefined}
            onPress={onPressLikeMarket.action}
          >
            {alreadyFavoriteMarket ? '이미 찜한 마켓' : `마켓 찜 하기`}
          </PrimaryButton>
        </Flex>
        <IconOnlyButton onPress={onPressCoupon} testID={'쿠폰버튼'}>
          <IconCoupon />
        </IconOnlyButton>
        <IconOnlyButton onPress={onPressShare} testID={'공유버튼'}>
          <IconShare />
        </IconOnlyButton>
      </Flex.Row>
    </Flex>
  );
};

export default MarketInfoWrapper;
